import { render, staticRenderFns } from "./ui-info.vue?vue&type=template&id=a61f0488&"
import script from "./ui-info.vue?vue&type=script&lang=ts&"
export * from "./ui-info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports